import { defineMessages } from 'react-intl';

import Switch from 'atoms/inputs/Switch';
import { useCurrentUserContext } from 'contexts/currentUser';

import SettingsSection from '../SettingsSection';
import useToggleHideCommonCards from './useToggleHideCommonCards';

const messages = defineMessages({
  title: {
    id: 'Settings.hideCommonCard.title',
    defaultMessage: 'Common Cards',
  },
  description: {
    id: 'Settings.hideCommonCard.description',
    defaultMessage: 'Always hide Commons in galleries',
  },
});

const HideCommonCards = () => {
  const { currentUser } = useCurrentUserContext();
  const toggleHideCommonCards = useToggleHideCommonCards();

  if (!currentUser) return null;

  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={currentUser?.userSettings?.hideCommonCards}
          onChange={() => {
            toggleHideCommonCards();
          }}
        />
      }
    />
  );
};

export default HideCommonCards;
